interface GradiantSkeltonTypes {
  width?: string
  height?: string
  className?: string
  children?: React.ReactNode
}

const GradiantSkelton = ({
  width,
  height,
  className,
}: GradiantSkeltonTypes) => {
  return (
    <div
      data-testid='skeleton-line'
      className={`
        ${width}
        ${height}
        relative overflow-hidden
        rounded-radius-full
        bg-gradient-to-l from-tertiary to-secondary
        ${className}
      `}
    >
      <div
        className='
          absolute inset-0
          h-full w-[200%]
          animate-shimmer
          bg-gradient-to-r
          from-transparent
          via-white/40
          dark:via-white/10
          to-transparent
        '
      />
    </div>
  )
}

export default GradiantSkelton
